export default function CADModalHelp({ setShowHelpModal, cadId, cadName }) {

    const handleRemoveModalHelp = (e) => {
        setShowHelpModal(false)
    };

    return (
        <form>
            <div className="flex-help-modal">
                <fieldset>
                    <legend>Aide pour les variables du courrier</legend>
                    <h1>Liste des variables pour personnaliser vos courriers {cadName}.</h1>
                    <ul>
                        { cadId === "14" &&
                            <>
                                <li><span>Conjoint :</span> $&#123;Conjoint&#125; (ligne précédée par <span>au nom de </span>)</li>
                                <li><span>Adresse du conjoint :</span> $&#123;Conjoint_Adresse&#125; (ligne précédée par <span>, habitant</span>)</li>
                            </>
                        }
                        { cadId === "07" &&
                            <>
                                <li>
                                    <span>Vérification de la présence ou non d'un conjoint :</span> $&#123;Condition_Conjoint&#125;
                                    <span>
                                        ☐ L'imprimé permettant une nouvelle immatriculation pour <span className="exemple">Civilité Prénom Nom Conjoint</span>
                                        ☐ L'imprimé d'une demande d'allocation veuvage pour <span className="exemple">Civilité Prénom Nom Conjoint</span>
                                        ☐ L'imprimé d'une demande d'aide médicale pour <span className="exemple">Civilité Prénom Nom Conjoint</span>
                                    </span>
                                </li>
                                <li>
                                    <span>Vérification de la présence ou non d'enfants mineurs :</span> $&#123;Condition_Enfants&#125;
                                    <span>
                                        Rattacher
                                        ☐ Sous le n° de sécurité sociale de <span className="exemple">Civilité Prénom Nom Conjoint</span> son ou ses enfant(s) :
                                        ☐ <span className="exemple">Prénom Nom Enfant</span> né(e) le <span className="exemple">Date de naissance Enfant</span>
                                        (si tuteur ) Tuteur : <span className="exemple">Civilité Prénom Nom Tuteur</span> , <span className="exemple">Adresse Tuteur</span>
                                        ☐ <span className="exemple">Prénom Nom Enfant</span> né(e) le <span className="exemple">Date de naissance Enfant</span>
                                        Le N° de sécurité sociale de <span className="exemple">Civilité Prénom Nom Conjoint</span> est le : ................................................
                                    </span>
                                </li>
                                <li><span>Aide obsèques :</span>$&#123;Aide_Obsèques&#125;
                                    <span>
                                        Confirmer
                                        ☐ Si le décès de <span className="exemple">Civilité Prénom Nom Défunt</span> est la conséquence d'un accident de travail ou d'une maladie
                                        professionnelle, de la possibilité que <span className="exemple">Civilité Prénom Nom Conjoint</span> bénéficie d'une rente et d'une aide pour le
                                        règlement des obsèques
                                    </span>
                                </li>
                            </>
                        }
                        {(
                            cadId === "13" ||
                            cadId === "29" ||
                            cadId === "22" ||
                            cadId === "19" ||
                            cadId === "20" ||
                            cadId === "32" ||
                            cadId === "31" ||
                            cadId === "30" ||
                            cadId === "39" ||
                            cadId === "40" ||
                            cadId === "44" ||
                            cadId === "46"
                        ) &&
                            <>
                                <li><span>Conjoint :</span> $&#123;Conjoint&#125; (ligne précédée par <span>au nom de </span>)</li>
                                <li><span>Adresse du conjoint :</span> $&#123;Conjoint_Adresse&#125; (ligne précédée par <span>, habitant</span>)</li>
                                <li><span>Gestionnaire :</span> $&#123;Gestionnaire&#125; (ligne précédée par <span>au nom de </span>)</li>
                                <li><span>Adresse du gestionnaire :</span> $&#123;Gestionnaire_Adresse&#125; (ligne précédée par <span>, habitant</span>)</li>
                                <li><span>Correspondant :</span> $&#123;Correspondant&#125; (ligne précédée par <span>au nom de </span>)</li>
                                <li><span>Adresse du correspondant :</span> $&#123;Correspondant_Adresse&#125; (ligne précédée par <span>, habitant</span>)</li>
                                <li><span>Tiers :</span> $&#123;Tiers&#125; (lignes vides précédées par <span>au nom de</span> et <span>,habitant</span>)</li>
                            </>
                        }
                        {cadId === "09" &&
                            <li>
                                <span>Vérification de la présence ou non d'un conjoint :</span> $&#123;Condition_Conjoint&#125;
                                <span>
                                    Préciser
                                    ☐ Les droits sociaux auxquels peut prétendre <span className="exemple">Civilité Prénom Nom Conjoint</span>
                                    Indiquez si vous allouez
                                    ☐ Un capital décès
                                    ☐ Une participation afin de faire face aux frais d'obsèques
                                    Transmettre
                                    ☐ L'imprimé de demande d'allocation décès pour <span className="exemple">Civilité Prénom Nom Conjoint</span>
                                    ☐ L'imprimé de demande de réversion pour <span className="exemple">Civilité Prénom Nom Conjoint</span>
                                    ☐ L'imprimé nécessaire à une demande d'allocation de soutien aux personnes âgées pour <span className="exemple">Civilité Prénom Nom Conjoint</span>
                                </span>
                            </li>
                        }
                        { cadId === "08" &&
                            <li><span>Vérification de la présence ou non d'un conjoint :</span> $&#123;Condition_Conjoint&#125;
                                <span>
                                    ☐ Si Mme <span className="exemple">Civilité Prénom Nom Conjoint</span> peut profiter du contrat et sous quelles conditions
                                    ☐ et dans ce cas, rattacher son ou ses enfants à son nom :
                                    <span className="exemple">Prénom Nom Enfant</span> né(e) le <span className="exemple">Date de naissance Enfant</span>
                                      (si tuteur ) Tuteur : <span className="exemple">Civilité Prénom Nom Tuteur</span> , <span className="exemple">Adresse Tuteur</span>
                                </span>
                            </li>
                        }
                        { cadId === "33" &&
                            <>
                                <li><span>Vérification de la présence ou non d'un conjoint :</span> $&#123;Condition_Conjoint&#125;
                                    <span>
                                        Faire le transfert ou la demande
                                        pour le compte de Mme Conjoint TEST, habitant rue du test, 75000 Paris des allocations suivantes :
                                        ☐ Allocations familiales : ☐ Transfert ☐ Demande
                                        ☐ Allocation logement : ☐ Transfert ☐ Demande
                                        ☐ RSA : ☐ Transfert ☐ Demande
                                        ☐ Allocation aux adultes handicapés : ☐ Transfert ☐ Demande
                                        ☐ Allocation veuvage : ☐ Demande
                                        ☐ Allocation d'éducation de l'enfant handicapé : ☐ Transfert ☐ Demande
                                        ☐ Allocation de soutien familial et/ou de parent isolé : ☐ Demande
                                    </span>
                                </li>
                                <li><span>Vérification de la présence ou non d'enfants mineurs :</span> $&#123;Condition_Enfants&#125;
                                    <span>
                                        ☐ Les enfants à charge sont :
                                        ☐ <span className="exemple">Prénom Nom Enfant</span> né(e) le <span className="exemple">Date de naissance Enfant</span>
                                        (si tuteur ) Tuteur : <span className="exemple">Civilité Prénom Nom Tuteur</span> , <span className="exemple">Adresse Tuteur</span>
                                    </span>
                                </li>
                            </>
                        }
                        { cadId === "45" &&
                            <li>
                                <span>Vérification du statut marital :</span> $&#123;Condition_Statut_Marital&#125;
                                <span>
                                    - si condition "en couple" <i>- sans mariage ni pacs mais présence de conjoint -</i> :
                                    ☐ Arrêter définitivement les prélèvements à compter de ce jour, hors compte joint
                                    <b>en vous priant de faire parvenir le ou les formulaire(s) nécessaire(s) à cette régulation</b>)
                                    - sinon : ☐ Arrêter définitivement les prélèvements à compter de ce jour, hors compte joint
                                </span>
                                <span>
                                    - si condition <b>"en couple"</b> ET si condition <b>"gestionnaire"</b> <i>- sans mariage ni pacs mais présence de conjoint -</i> :
                                    ☐ Prendre note du fait que <span className="exemple">Civilité Prénom Nom Gestionnaire</span>
                                     vous fera parvenir la déclaration d’impôt concernant les revenus en cours
                                     en vous priant de faire parvenir le ou les formulaire(s) nécessaire(s) à cette régulation
                                    - si condition <b>"en couple"</b> ET si condition <b>"correspondant"</b> <i>- sans mariage ni pacs mais présence de conjoint -</i> :
                                    ☐ Prendre note du fait que <span className="exemple">Civilité Prénom Nom Correspondant</span>
                                     vous fera parvenir la déclaration d’impôt concernant les revenus en cours
                                     en vous priant de faire parvenir le ou les formulaire(s) nécessaire(s) à cette régulation
                                </span>
                                <span>
                                    - si condition "Marié ou Pacsé" :
                                    ☐ Prendre note du fait que <span
                                    className="exemple">Civilité Prénom Nom Conjoint</span> vous fera parvenir deux déclarations d'impôts concernant
                                    les revenus en cours :
                                    - La déclaration conjointe de <span className="exemple"> Civilité Défunt et Civilité Conjoint Nom</span>
                                    - La déclaration de <span className="exemple">Civilité Nom Défunt</span> en vous priant de faire parvenir le ou les formulaire(s) nécessaire(s) à
                                    cette régulation
                                </span>
                            </li>
                        }
                    </ul>
                    <ul>
                        <li><h3>Variables générales</h3></li>
                        <li><h3>Ville contextuelle</h3></li>
                        <li><span>Ville actuelle :</span> $&#123;Ville_Actuelle&#125;</li>
                        <li><h3>Date</h3></li>
                        <li><span>Date :</span> $&#123;Date&#125;</li>
                        <li><h3>Civilités, noms, prénoms</h3></li>
                        <li><span>Civilité, prénom et nom du défunt :</span> $&#123;Défunt&#125;</li>
                        <li><span>Civilité, prénom et nom du conjoint :</span> $&#123;Conjoint&#125;</li>
                        <li><span>Civilité, prénom et nom du gestionnaire :</span> $&#123;Gestionnaire&#125;</li>
                        <li><span>Civilité, prénom et nom du correspondant :</span> $&#123;Correspondant&#125;</li>
                        {/*<li><span>Civilité, prénom et nom du notaire :</span> $&#123;Notaire&#125; (ligne précédée par <span>ainsi qu'à Me </span>)</li>*/}
                        <li><span>Ligne vide :</span> $&#123;Tiers&#125;</li>
                        <li><h3>Contexte du défunt</h3></li>
                        <li><span>Nom du défunt :</span> $&#123;Défunt_nom&#125;</li>
                        <li><span>Civilité longue, prénom et nom du défunt :</span> $&#123;Défunt_long&#125;</li>
                        <li><span>Nom de naissance du défunt :</span> $&#123;Défunt_nom_naissance&#125;</li>
                    </ul>
                    <ul>
                        <li><h3>Adresses</h3></li>
                        <li><span>Adresse complète du défunt :</span> $&#123;Défunt_Adresse&#125;</li>
                        <li><span>Adresse complète du conjoint :</span> $&#123;Conjoint_Adresse&#125;</li>
                        <li><span>Adresse complète du gestionnaire :</span> $&#123;Gestionnaire_Adresse&#125;</li>
                        <li><span>Adresse complète du correspondant :</span> $&#123;Correspondant_Adresse&#125;</li>
                        {/*<li><span>Adresse complète du notaire :</span> $&#123;Notaire_Adresse&#125;</li>*/}
                        <li><span>Ligne vide :</span> $&#123;Tiers_Adresse&#125;</li>
                    </ul>
                    <div className="flex">
                        <button type="button" onClick={(e) => handleRemoveModalHelp(e)}>Cacher</button>
                    </div>
                </fieldset>
            </div>

        </form>
    )
}